import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk для загрузки build info
export const fetchBuildInfo = createAsyncThunk(
    'app/fetchBuildInfo',
    async () => {
        try {
            const response = await fetch('/build-info.json');
            if (response.ok) {
                return await response.json();
            }
            throw new Error('Build info not found');
        } catch (error) {
            // Fallback - используем переменные окружения
            const envHash = import.meta.env.VITE_GIT_HASH || 'dev';
            const envBuildTime = import.meta.env.VITE_BUILD_TIME || new Date().toISOString();
            const envAppVersion = import.meta.env.VITE_APP_VERSION || '0.0.0';
            
            return {
                hash: envHash,
                shortHash: envHash,
                timestamp: envBuildTime,
                version: import.meta.env.PROD ? 'production' : 'development',
                buildTime: envBuildTime,
                appVersion: envAppVersion
            };
        }
    }
);

const appSlice = createSlice({
    name: 'app',
    initialState: {
        buildInfo: {
            hash: 'unknown',
            shortHash: 'unknown',
            timestamp: 'unknown',
            version: 'dev',
            buildTime: 'unknown',
            appVersion: '0.0.0'
        },
        loading: false,
        error: null
    },
    reducers: {
        clearAppData: (state) => {
            state.buildInfo = {
                hash: 'unknown',
                shortHash: 'unknown',
                timestamp: 'unknown',
                version: 'dev',
                buildTime: 'unknown',
                appVersion: '0.0.0'
            };
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBuildInfo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBuildInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.buildInfo = action.payload;
                state.error = null;
            })
            .addCase(fetchBuildInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { clearAppData } = appSlice.actions;
export default appSlice.reducer;
